/*
 * SPDX-FileCopyrightText: 2025 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { cypressId } from '../../../utils/cypress-attribute'
import { IconButton } from '../icon-button/icon-button'
import { useOpenNewPageModal } from '../page-settings-modal/new-page-modal-context'
import React, { useCallback } from 'react'
import { FileEarmarkPlus as IconPlus } from 'react-bootstrap-icons'
import { Trans } from 'react-i18next'
import { useFrontendConfig } from '../frontend-config-context/use-frontend-config'
import { PermissionLevel } from '@hedgedoc/commons'
import { useIsLoggedIn } from '../../../hooks/common/use-is-logged-in'

/**
 * Opens the modal to create a new page
 */
export const NewNoteButton: React.FC = () => {
  const openNewPageModal = useOpenNewPageModal()
  const guestAccessLevel = useFrontendConfig().guestAccess
  const isLoggedIn = useIsLoggedIn()

  const onClick = useCallback(() => openNewPageModal(), [openNewPageModal])

  if (!isLoggedIn && guestAccessLevel !== PermissionLevel.FULL) {
    return null
  }

  return (
    <IconButton {...cypressId('new-note-button')} iconSize={1.5} size={'sm'} icon={IconPlus} onClick={onClick}>
      <Trans i18nKey='navigation.newNote' />
    </IconButton>
  )
}
